export default __webpack_public_path__ + "static/media/394.4f9b0809.jpg";